// Constants for theater preferences

// Define the days of the week
export const DAYS_OF_WEEK = [
  { id: 'THU', label: 'Thursday' },
  { id: 'FRI', label: 'Friday' },
  { id: 'SAT', label: 'Saturday' },
  { id: 'SUN', label: 'Sunday' },
]

// Define common time windows
export const TIME_WINDOWS = [
  { id: 'morning', label: 'Morning (9AM-12PM)', startTime: '09:00', endTime: '12:00' },
  { id: 'afternoon', label: 'Afternoon (12PM-5PM)', startTime: '12:00', endTime: '17:00' },
  { id: 'evening', label: 'Evening (5PM-8PM)', startTime: '17:00', endTime: '20:00' },
  { id: 'night', label: 'Night (8PM-12AM)', startTime: '20:00', endTime: '00:00' },
]
